import { useContext } from 'react';
import UniverseContext from '../context/UniverseContext';

export default function useUniverse() {
    return useContext(UniverseContext);
}
